import {takeEvery} from 'redux-saga';
import http from './../_utils/httpSaga';
import {toastr} from 'react-redux-toastr';
import {put} from 'redux-saga/effects';

import {
  FETCH_GROOMER_PLANNING,
  ADD_JUSTIFICATION,
  fetchGroomerPlanningForYearAndMonthFailure,
  fetchGroomerPlanningForYearAndMonthSuccess,
  fetchGroomerPlanningForYearAndMonth,
  addJustificationSuccess,
  addJustificationFailure
} from './actions';


function* fetchPlanning({groomer, month, year}) {
  const url = `/api/groomer/${groomer.id}/planning/${year}/${month}`;
  let result = yield http.json.get(url);

  if (result instanceof Error) {
    toastr.error(`Echec de la récupération du planning ${groomer.id}`);
    yield put(fetchGroomerPlanningForYearAndMonthFailure(result, groomer, year, month));
  } else {
    yield put(fetchGroomerPlanningForYearAndMonthSuccess(result, groomer, year, month));
  }

}

function* addJustification({groomer, month, year, day, message}) {
  const url = `/api/groomer/${groomer.id}/justification/${year}/${month}/${day}`;
  let result = yield http.json.post(url, {message});

  if (result instanceof Error) {
    toastr.error('Echec d\'enregistrement de la justification');
    yield put(addJustificationFailure(e));
  } else {
    yield put(addJustificationSuccess(groomer, year, month, day, message));
    yield put(fetchGroomerPlanningForYearAndMonth(groomer, year, month));
  }
}


export default function*() {
  yield [
    takeEvery(FETCH_GROOMER_PLANNING.do, fetchPlanning),
    takeEvery(ADD_JUSTIFICATION.do, addJustification)
  ];
}



// WEBPACK FOOTER //
// ./src/redux/planning/saga.js